<template>
	<v-dialog v-model="openD" max-width="820" persistent>
		<v-card>
			<v-card-title class="headline pb-0">
				<span v-html="heading"></span>
			</v-card-title>
			<v-container fluid grid-list-sm>
				<v-layout row wrap>
					<v-flex xs12>
						<v-switch
								v-model="result.esEntrega"
								label="Se realizó entrega"
                class="pa-0 ma-0"
								:false-value="0"
								:true-value="1"
						></v-switch>
					</v-flex>
					<v-flex xs12 v-if="programacion">
						<label class="caption grey--text darken-3">Código de servicio / tecnología a entregar segun programación No. {{programacion.id}}</label>
						<span>
							<a @click="getDetalleTechnologi(programacion.TipoTec, programacion.CodSerTecAEntregar)">{{programacion.TipoTec}} {{programacion.CodSerTecAEntregar}}</a>
							<v-tooltip top>
								<v-btn slot="activator" class="mx-0 mt-0" icon small @click="editaSerTec = true">
									<v-icon color="orange" small>fas fa-pen</v-icon>
								</v-btn>
								<span>Editar código</span>
							</v-tooltip>
						</span>
						<v-text-field
								v-if="editaSerTec === true"
								label="Código de servicio / tecnología a entregar"
								v-model="result.CodSerTecEntregado"
								name="Código de servicio / tecnología a entregar"
								:prefix="programacion.TipoTec"
								v-validate="'required'"
								:error-messages="errors.collect('Código de servicio / tecnología a entregar').length ? errors.collect('Código de servicio / tecnología a entregar') : 'EasyMipres no se hace responsable por el cambio del código del servicio y/o tecnología a entregar en este proceso.'"
						>
							<template v-slot:append-outer>
								<v-tooltip top>
									<v-btn slot="activator" icon large @click="editaSerTec = false">
										<v-icon color="primary">fas fa-reply-all</v-icon>
									</v-btn>
									<span>Cancelar edición de código</span>
								</v-tooltip>
							</template>
						</v-text-field>
					</v-flex>
					<template v-if="result.esEntrega">
            <v-flex v-if="programacion && programacion.TipoTec === 'M'" xs12>
              <v-alert :value="true" color="info" icon="info" class="pa-1">
                Se debe ingresar el Número de lote para los casos de los medicamentos de compra directa para Hepatitis C.
              </v-alert>
              <v-switch
                  v-model="result.NoLoteEntregado"
                  label="Ingresar número de lote entregado"
                  :false-value="0"
                  :true-value="1"
                  hide-details
              />
              <v-text-field
                  v-if="result.NoLoteEntregado"
                  key="NoLote"
                  label="Número de lote entregado"
                  v-model="result.NoLote"
                  name="Número de lote"
                  v-validate="'required'"
                  :error-messages="errors.collect('Número de lote')"
              />
            </v-flex>
						<v-flex xs12>
							<v-menu
									key="menu"
									ref="fechaEntrega"
									v-model="fechaEntrega.menu"
									:close-on-content-click="false"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
							>
								<v-text-field
										key="FecEntrega"
										slot="activator"
										label="Fecha entrega"
										v-model="result.FecEntrega"
										name="Fecha entrega"
										prepend-icon="event"
										v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaEntrega.minDate + ',' + fechaEntrega.maxDate + ',true'"
										:error-messages="errors.collect('Fecha entrega')"
										readonly
								></v-text-field>
								<v-date-picker
										key="picker"
										ref="picker"
										v-model="result.FecEntrega"
										locale="es-co"
										:min="fechaEntrega.minDate"
										:max="fechaEntrega.maxDate"
										@input="$refs.fechaEntrega.save(result.FecEntrega)"
										@change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha entrega')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
								></v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs12 sm12 :md6="reporteAutomatico" :md12="!reporteAutomatico">
							<v-text-field
									key="CantTotEntregada"
									label="Cantidad a entregar"
									v-model.number="result.CantTotEntregada"
									name="Cantidad a entregar"
									type="number"
									min="0"
									:max="programacion ? programacion.CantTotAEntregar : 0"
									v-validate="'required|min_value:0|max_value:' + (programacion ? programacion.CantTotAEntregar : 0)"
									:error-messages="errors.collect('Cantidad a entregar')"
									:hint="`Precio unitario: ${valorSerTecBase || valorSerTecBase === 0 ? currency(valorSerTecBase) : '$ _'}`"
									persistent-hint
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm12 md6 v-if="reporteAutomatico">
							<v-text-field
									v-if="!valorSerTecBase"
									key="Valor"
									label="Valor entregado"
									v-model.number="result.ValorEntregado"
									name="Valor entregado"
									type="number"
									min="0"
									v-validate="'required|min_value:0|decimal:2'"
									:error-messages="errors.collect('Valor entregado')"
							>
							</v-text-field>
							<template v-else>
								<template v-if="editaPrecio === false">
									<label class="caption grey--text darken-3">Valor entregado</label>
									<span>
									{{valorSerTec || valorSerTec === 0 ? currency(valorSerTec) : '$ _'}}
									<v-tooltip top>
										<v-btn slot="activator" class="mx-0 mt-0" icon small @click="editaPrecio = true">
											<v-icon color="orange" small>fas fa-pen</v-icon>
										</v-btn>
										<span>Editar valor entregado</span>
									</v-tooltip>
								</span>
								</template>
								<v-text-field
										v-if="editaPrecio === true"
										key="Valor"
										autofocus
										label="Valor entregado"
										v-model.number="result.ValorEntregado"
										name="Valor entregado"
										type="number"
										min="0"
										v-validate="'required|min_value:0|decimal:2'"
										:error-messages="errors.collect('Valor entregado')"
								>
									<template v-slot:append-outer>
										<v-tooltip top>
											<v-btn class="mt-0" slot="activator" icon @click="editaPrecio = false">
												<v-icon color="primary">fas fa-reply-all</v-icon>
											</v-btn>
											<span>Cancelar edición del valor entregado</span>
										</v-tooltip>
									</template>
								</v-text-field>
							</template>
						</v-flex>
						<v-flex xs12>
							<v-switch
									key="EntTotal"
									v-model="result.EntTotal"
									label="Se realizó entrega total"
                  class="pa-0"
									:false-value="0"
									:true-value="1"
							></v-switch>
						</v-flex>
						<v-flex xs12>
							<v-card>
								<v-toolbar>
									<v-icon>ti ti-user</v-icon>
									<v-toolbar-title style="display: flex; flex-direction: column;">
                    <span>Persona que recibe</span>
                    <v-btn small color="primary" class="ma-0 text-none" @click="putPatientData">Aplicar datos del paciente</v-btn>
                  </v-toolbar-title>
								</v-toolbar>
								<v-card-text>
									<v-select
											label="Tipo identificación"
											v-model="result.TipoIDRecibe"
											:items="identificationTypes"
											item-value="value"
											item-text="text"
											name="tipo identificación"
											v-validate="'required'"
											:error-messages="errors.collect('tipo identificación')"
									></v-select>
									<v-text-field
											label="Identificación"
											v-model="result.NoIDRecibe"
											name="identificación"
											v-validate="'required'"
											:error-messages="errors.collect('identificación')"
									></v-text-field>
								</v-card-text>
							</v-card>
						</v-flex>
					</template>
					<template v-else>
						<v-flex xs12>
							<v-autocomplete
									label="Causa de no entrega"
									v-model="result.CausaNoEntrega"
									:items="causasAplicables"
									item-value="id"
									item-text="causa"
									:filter="filterCausas"
							>
								<template slot="selection" slot-scope="data">
									<div style="width: 100% !important;">
										<v-list-tile>
											<v-list-tile-content>
												<v-list-tile-title>{{data.item.causa}}</v-list-tile-title>
												<v-list-tile-sub-title class=caption>Aplica a: {{data.item.aplica_a}}</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>
									</div>
								</template>
								<template slot="item" slot-scope="data">
									<div style="width: 100% !important;">
										<v-list-tile>
											<v-list-tile-content>
												<v-list-tile-title>{{data.item.causa}}</v-list-tile-title>
												<v-list-tile-sub-title class=caption>Aplica a: {{data.item.aplica_a}}</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>
									</div>
								</template>
							</v-autocomplete>
						</v-flex>
					</template>
				</v-layout>
				<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="load = false"></detail-technologi-dialog>
			</v-container>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
						:disabled="load"
				>
					Cancelar
				</v-btn>
				<v-btn
						color="primary"
						:loading="load"
						:disabled="load"
						@click="submit"
				>
					Registrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { mapState } from 'vuex'
export default {
  	props: ['heading'],
    data: () => ({
		editaSerTec: false,
		editaPrecio: false,
		valorSerTecBase: null,
        openD: false,
        load: false,
        fechaEntrega: {
            menu: false,
            minDate: '1900-01-01',
            maxDate: new Date().toISOString().substr(0, 10)
        },
		causasNoEntrega: [],
		programacion: null,
    result: {
      esEntrega: 1,
      programacion_id: null,
      CodSerTecEntregado: null,
      CantTotEntregada: null,
      EntTotal: 0,
      FecEntrega: null,
      CausaNoEntrega: null,
      ValorEntregado: null,
      TipoIDRecibe: null,
      NoIDRecibe: null,
      NoLoteEntregado: 0,
      NoLote: null,
		},
        settings: null,
        filterCausas: (item, queryText) => this.getFilter(item, queryText, item.id + ' ' + item.causa + ' ' + item.aplica_a)
	}),
	watch: {
  		valorSerTec (val) {
  			this.result.ValorEntregado = val
		},
  		'editaPrecio' (val) {
  			if (!val) {
  				this.result.ValorEntregado = this.valorSerTec
			}
		},
  	    'editaSerTec' (val) {
  			if (!val) {
  				this.result.CodSerTecEntregado = this.programacion.CodSerTecAEntregar
			}
		},
  	    'result.esEntrega' (val) {
  	        !val && this.causasNoEntrega.length < 1 && this.getCausasNoEntrega()
		},
    'result.NoLoteEntregado' (val) {
      this.result.NoLote = !val ? 0 : null
    }
	},
	computed: {
		permisos () {
			return this.$store.getters.getPermissionModule('precios')
		},
  		valorSerTec () {
  			if (this && (this.valorSerTecBase || this.valorSerTecBase === 0) && (this.result.CantTotEntregada || this.result.CantTotEntregada === 0)) {
  				return  (this.valorSerTecBase * this.result.CantTotEntregada)
			}
  			return null
		},
  		reporteAutomatico () {
  			return this.settings && this.settings[1] && this.settings[1].value === '1'
		},
		...mapState({
			identificationTypes: state => state.general.identificationTypes.filter(x => x.recibeEntrega)
		}),
  	  causasAplicables () {
		  if (this.programacion) {
              const tipos = {
                  M: 'medicamentos',
				  P: 'procedimientos',
				  D: 'dispositivos',
				  N: 'nutricionales',
				  S: 'complementarios'
              }
              return this.result && !this.result.esEntrega && this.causasNoEntrega.length ? this.causasNoEntrega.filter(x => x[tipos[this.programacion.TipoTec]] === 1) : []
		  }
  	      return []
	  }
	},
	methods: {
    putPatientData () {
      this.result.TipoIDRecibe = this.programacion.TipoIDPaciente
      this.result.NoIDRecibe = this.programacion.NoIDPaciente
    },
		getDetalleTechnologi (type, code) {
			this.load = true
			this.$refs.dialogInfoTechnologi.getDetail(type, code)
		},
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    let data = null
					if (this.result.esEntrega) {
            data = {
                programacion_id: this.programacion.id,
                CodSerTecEntregado: this.result.CodSerTecEntregado,
                CantTotEntregada: this.result.CantTotEntregada,
                EntTotal: this.result.EntTotal,
                FecEntrega: this.result.FecEntrega,
                TipoIDRecibe: this.result.TipoIDRecibe,
                NoIDRecibe: this.result.NoIDRecibe,
                NoLoteEntregado: this.result.NoLoteEntregado,
                NoLote: this.result.NoLote || null
            }
            if (this.reporteAutomatico) {
              if (this.result.ValorEntregado || this.result.ValorEntregado === 0) {
								data.ValorEntregado = this.valorDecimal(this.result.ValorEntregado)
							} else {
								this.$store.commit('snackbar', {color: 'error', message: `El servicio / tecnología no tiene un valor de entrega válido.`})
								return
							}
						}
					} else {
					    data = {
                            programacion_id: this.programacion.id,
                            CausaNoEntrega: this.result.CausaNoEntrega,
                            // TipoIDRecibe: this.programacion.TipoIDPaciente, aplica solo para entregas
                            // NoIDRecibe: this.programacion.NoIDPaciente aplica solo para entregas
                            // CantTotEntregada: 2, aplica para parcial
                            // FecEntrega: '2019-08-30' aplica para parcial
                        }
					}
					this.loading()
                    this.axios.post(`entregas`, data)
                        .then((response) => {
                            this.$store.commit('snackbar', {color: 'success', message: `La ${this.result.esEntrega ? 'ENTREGA' : 'NO ENTREGA'} se registró correctamente`})
                            this.$store.commit('reloadTable', 'tableProgramaciones')
                            this.$store.commit('reloadTable', 'tableEntregas')
                            this.close()
                        }).catch(e => {
                        this.loading(false)
                        this.$store.commit('snackbar', {color: 'error', message: `al registrar la ${this.result.esEntrega ? 'ENTREGA' : 'NO ENTREGA'}`, error: e})
                    })
				}
            })
		},
        getCausasNoEntrega () {
            this.loading()
            this.axios.get(`causasnoentregas`)
                .then(response => {
					this.causasNoEntrega = response.data
                    this.loading(false)
                }).catch(e => {
                this.loading(false)
                this.$store.commit('snackbar', {color: 'error', message: `al traer las causas de no entrega.`, error: e})
            })
        },
        getSettings () {
            this.axios.get(`settings`)
                .then(response => {
                    this.settings = response.data
                }).catch(e => {
                this.$store.commit('snackbar', {color: 'error', message: `al traer la configuración global.`, error: e})
            })
		},
		getPrecio () {
			this.axios.get(`precios/consultar?TipoTec=${this.programacion.TipoTec}&CodSerTec=${this.programacion.CodSerTecAEntregar}`)
					.then(response => {
						this.valorSerTecBase = response.data || null
					}).catch(e => {
				this.$store.commit('snackbar', {color: 'error', message: `al traer el precio del servicio/tecnología ${this.programacion.TipoTec} ${this.programacion.CodSerTecAEntregar}.`, error: e})
			})
		},
		open (programacion) {
  	        this.programacion = programacion
			this.result.CodSerTecEntregado = this.programacion.CodSerTecAEntregar
            this.getSettings()
			this.getPrecio()
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
            setTimeout(() => {
                this.load = false
                this.result.programacion_id = null
                this.result.CodSerTecEntregado = null
                this.result.CantTotEntregada = null
                this.result.EntTotal = 0
                this.result.esEntrega = 1
                this.result.FecEntrega = null
                this.result.CausaNoEntrega = null
                this.result.ValorEntregado = null
                this.result.TipoIDRecibe = null
                this.result.NoIDRecibe = null
                this.result.NoLoteEntregado = 0
                this.result.NoLote = null
                this.$validator.reset()
                this.settings = null

				this.editaSerTec = false
				this.editaPrecio = false
				this.valorSerTecBase = null
            }, 300)
		},
        getFilter (item, queryText, compareString) {
            const hasValue = val => val != null ? val : ''
            const text = hasValue(compareString)
            const query = hasValue(queryText)
            return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
  	}
}
</script>

